import { render, staticRenderFns } from "./Contrast.vue?vue&type=template&id=19b0abe0"
import script from "./Contrast.vue?vue&type=script&lang=ts"
export * from "./Contrast.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports